export { DetailsTopIcons } from './DetailsTopIcons';
